import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import UIUtils from '../../../lib/UIUtils';
import { Button } from 'new/elements/support/Button';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { FILE_REINGESTION_REQUEST } from 'js/constants/actionTypes';

const styles = {
  title: {
    fontSize: 16,
    wordBreak: 'break-all',
    color: `var(--color-greyscale-800, #2F3037)`,
    fontStyle: 'normal',
    fontWeight: '500',
  },
  subtitle: {
    fontSize: 14,
    color: `var(--color-greyscale-800, #2F3037)`,
    fontStyle: 'normal',
    fontWeight: '400',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  cancelButton: {
    border: 'none',
    color: `var(--color-greyscale-800, #2F3037)`,
    backgroundColor: `var(--color-greyscale-50, #F1F2F3)`,
  },
  reingestButton: {
    minWidth: '189px',
    color: 'white',
    backgroundColor: `var(--color-warning-600, #DBA707)`,
  },
} as any;

export function ReingestDialogContent({ file, onClose, onConfirm }) {
  const loading = useIsLoading(FILE_REINGESTION_REQUEST);

  if (!file) return null;

  let displayPath = (() => {
    if (Array.isArray(file)) {
      return UIUtils.toPluralFormat('file', file.length);
    }
    return file.metadata?.display_path || file?.path || file?.name;
  })();

  return (
    <>
      <DialogTitle>
        <div style={styles.title}>Confirm File Re-Ingest</div>
      </DialogTitle>
      <DialogContent>
        <div style={styles.subtitle}>
          <b>{displayPath}</b> will be queued for re-ingestion and will be processed in the next
          scheduled ingestion cycle.
        </div>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose} style={styles.cancelButton}>
          Cancel
        </Button>
        <Button
          disabled={loading}
          variant="contained"
          color="warning"
          onClick={onConfirm}
          style={styles.reingestButton}
        >
          {loading ? 'loading' : 'Queue for Re-Ingestion'}
        </Button>
      </DialogActions>
    </>
  );
}
